import { useParams } from "react-router-dom";
import { Header } from "./Header";

const WHATSAPP_NUMBER = "56934257972";

function buildWhatsAppUrl(token: string): string {
  const text = `Hola, acabo de llenar el formulario de contacto en risk594.com. Mi referencia es ${token}.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function Gracias() {
  const { token } = useParams<{ token: string }>();
  const safeToken = (token ?? "").slice(0, 16).replace(/[^A-Za-z0-9]/g, "");

  if (!safeToken) {
    return (
      <div className="container">
        <Header />
        <div className="gracias">
          <h1>No encontramos tu referencia.</h1>
          <p className="lead">
            Si llegaste directo a esta página, por favor completa el formulario primero.
          </p>
          <a href="/" className="whatsapp-btn" style={{ background: "#0A364C" }}>
            Volver al formulario
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <Header />
      <div className="gracias">
        <div className="gracias-check">✓</div>
        <h1>Recibimos tu mensaje.</h1>
        <p className="lead">
          Tu referencia es:
        </p>
        <div className="token-pill">{safeToken}</div>
        <p className="lead">
          Haz clic en el botón para abrir WhatsApp y acelerar la conversación. Si no respondes
          dentro de 24 horas, te escribimos nosotros al teléfono que dejaste.
        </p>
        <a
          href={buildWhatsAppUrl(safeToken)}
          className="whatsapp-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Abrir WhatsApp
        </a>
      </div>
      <footer className="legal">
        Guarda tu referencia por si necesitas hacer seguimiento.
        <br />
        Azul Profundo SpA · RUT 78.022.067-8 · Marca Risk594
      </footer>
    </div>
  );
}
